<template>
  <div class="main-wrapper" :class="!minibar ? '' : 'mini-sidebar'">
  	 <Header />
    <Sidebar />
    <div class="page-wrapper">
      <div class="container-fluid">
    	   <router-view />
      </div>   
	</div>   
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";  
import Header from "../components/Dashboard/Topbar_Diklat";
import Sidebar from "../components/Dashboard/Diklat";	
export default {
  computed: {
    ...mapState({
       minibar: state => state.minibar
    })
  },
	components: {
   		Header,
    	Sidebar
  	},
	 name: "diklat",
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/layout/diklat.vue